<script setup>
import {onMounted} from "vue";

const authStore = useAuthStore();
import {useAuthStore} from "@/stores/authStore";

onMounted(authStore.logout)
</script>